import type { MetaFunction } from '@remix-run/node';

import { getCanonicalURL } from '~/utils/getCanonicalURL';

import { type loader } from './loader';

export const meta: MetaFunction<
	never,
	{ [routeId: string]: typeof loader }
> = ({ location, matches }) => {
	const data = matches.find(match => /landing-page$/.test(match.id))?.data;

	return [
		{
			title: `Subscribe`,
		},
		{
			name: 'description',
			content: `Subscribe to OddsChecker`,
		},
		{
			tagName: 'link',
			rel: 'canonical',
			href: getCanonicalURL(data?.url.toString(), location.pathname),
		},
	];
};
